import { type Dispatch, type SetStateAction } from "react"
import { View, TouchableOpacity } from "react-native"
import BFText from "@/components/standard/BFText"
import CustomCompAdjustmentView from "@/components/customizecomps/CustomCompAdjustmentView"

interface PillOptionType {
  value: string
  name: string
  selected?: boolean
}

interface CustomCompPillsProps {
  title: string
  subtitle: string
  values: string[]
  options: PillOptionType[]
  onValuesChanged:
    | ((val: string[]) => void)
    | Dispatch<SetStateAction<string[]>>
}

const CustomCompPills: React.FC<CustomCompPillsProps> = ({
  title,
  subtitle,
  values,
  options,
  onValuesChanged,
}: CustomCompPillsProps) => {
  const toggleSelection = (option: PillOptionType) => {
    const newValues = [...values]
    const val: string = option.value

    const anyIdx = newValues.indexOf("Any")
    if (anyIdx >= 0) {
      newValues.splice(anyIdx, 1)
    }

    const idx = newValues.indexOf(val)
    if (idx >= 0) {
      newValues.splice(idx, 1)
    } else {
      newValues.push(val)
    }
    onValuesChanged(newValues)
  }

  const toggledOptions = options.map((option) => ({
    ...option,
    selected: values.includes(option.value),
  }))

  const numColumns = 2
  const numRows = Math.ceil(toggledOptions.length / numColumns)

  return (
    <CustomCompAdjustmentView title={title} subtitle={subtitle}>
      <View className="flex flex-col w-full items-center">
        {[...Array(numRows)].map((_, rowIndex) => (
          <View
            key={rowIndex}
            className="flex flex-row justify-center w-full mb-2"
          >
            {toggledOptions
              .slice(rowIndex * numColumns, (rowIndex + 1) * numColumns)
              .map((option, index) => (
                <View
                  key={`feature-buttons-${title}-${option.value}-${index}`}
                  className="p-2"
                >
                  <TouchableOpacity
                    testID={`${option.value}-button`}
                    className={`w-[120px] h-[30px] items-center justify-center rounded-[15px] border ${option.selected ? "border-calm-blue bg-calm-blue" : "border-warm-grey bg-white"}`}
                    onPress={() => {
                      toggleSelection(option)
                    }}
                  >
                    <BFText
                      className={`text-[12px] font-spacegrotesk ${option.selected ? "text-white" : "text-warm-grey"}`}
                    >
                      {option.name}
                    </BFText>
                  </TouchableOpacity>
                </View>
              ))}
          </View>
        ))}
      </View>
    </CustomCompAdjustmentView>
  )
}

export default CustomCompPills
